import fetch from "auth/FetchInterceptorAppManager";

const ProtectedRoutesService = {};

ProtectedRoutesService.getProtectedRoutes = function () {
  return fetch({
    url: "am/usermenu/routes?applicationId=LOS",
    method: "get",
  });
};

export default ProtectedRoutesService;
